module.exports = __webpack_public_path__ + "static/media/3.d57e99eb.svg";